import { PropsWithChildren, useState } from "react"
import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { Box, Grid, IconButton, Step, StepLabel, Stepper, Typography } from "@mui/material"
import { StandardDialog } from "../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { CreateUpdateProductFormValues, PriceList } from "../../productsTypes"
import { PriceListSpecifyPrice } from "./PriceListSpecifyPrice"
import { PriceListTable } from "./PriceListTable"

type AddToPriceListDialogProps = Readonly<
    PropsWithChildren<{
        open: boolean
        onClose: () => void
        dialogStateId: null | number
    }>
>

const useStyles = makeStyles()((theme) => ({
    dialogPaper: {
        padding: "1rem",
        justifyContent: "center",
        maxWidth: "73rem",
    },
    container: {
        gap: "2rem",
    },
    content: {
        width: "100%",
        padding: "0 5rem",
    },

    stepper: {
        maxWidth: "25rem",
        margin: "0 auto",
    },
}))

export function AddToPriceListDialog({ open, onClose, dialogStateId }: AddToPriceListDialogProps) {
    const { values, setFieldValue } = useFormikContext<CreateUpdateProductFormValues>()

    const { classes, cx } = useStyles()
    const [activeStep, setActiveStep] = useState(0)
    const [priceListId, setPriceListId] = useState<null | number>(null)

    const handleNext = () => {
        const newActiveStep = activeStep + 1
        setActiveStep(newActiveStep)
    }

    const handleAdd = (el: PriceList) => {
        if (values.priceLists) {
            const index = dialogStateId && values.priceLists.findIndex((item) => item.id === dialogStateId)
            const list = values.priceLists || []

            if (index !== null && index !== -1) {
                list[index] = el
            } else {
                list.push(el)
            }
            setFieldValue("priceLists", list)
        } else setFieldValue("priceLists", [el])

        onClose()
    }

    return (
        <StandardDialog
            open={open}
            onClose={onClose}
            dialogTitle={
                <LocalizedStrict id="product-create-add-to-price-list">
                    <>Add to price list</>
                </LocalizedStrict>
            }
            slotProps={{ paper: { className: classes.dialogPaper } }}
            scroll="body"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                direction="column"
                wrap="nowrap"
                className={classes.container}
            >
                <Box className={classes.content}>
                    <Stepper activeStep={activeStep} nonLinear className={classes.stepper}>
                        <Step completed={true}>
                            <StepLabel>
                                <LocalizedStrict id="product-create-price-list-step-one">
                                    <>Select price list</>
                                </LocalizedStrict>
                            </StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>
                                <LocalizedStrict id="product-create-price-list-step-two">
                                    <>Specify price</>
                                </LocalizedStrict>
                            </StepLabel>
                        </Step>
                    </Stepper>
                </Box>
                <Box className={classes.content}>
                    {!activeStep ? (
                        <PriceListTable
                            handleSelectPriceList={(id) => {
                                handleNext()
                                setPriceListId(id)
                            }}
                        />
                    ) : (
                        priceListId && <PriceListSpecifyPrice id={priceListId} handleAdd={handleAdd} />
                    )}
                </Box>
            </Grid>
        </StandardDialog>
    )
}
